import React from 'react';
import 'rapidoc';
import spec from './documentation.yaml';

const ApiDocumentation = () => {
    return (
        <rapi-doc
            spec-url={spec}
            show-header="false"
            allow-spec-url-load="false"
            allow-spec-file-load="false"
            render-style="focused"
            theme="light"
            font-size="large"
            regular-font="Open Sans"
            primary-color="#E91E63"
            nav-item-spacing="compact"
            nav-accent="colored-block"
            show-info="true"
            allow-authentication="true"
            allow-search="true"
            allow-advanced-search="true"
            show-components="true"
            method-style="as-colored-block"
            sort-endpoints-by="path"
            default-schema-tab="example"
            schema-style="table"
            schema-expand-level="1"
            default-schema-hide-read-only="true"
            multiline-description-headers="true"
            show-method-in-nav-bar="as-colored-block"
            allow-try="true"
            show-curl-before-try="true"
            show-schema-description-expand-toggle="true"
            style={{height: "100vh", width: "100%"}}
        >
        </rapi-doc>
    );
};

export default ApiDocumentation;